function setContentMarginBottom() {
    const element = document.getElementById('vikon-footer');
    if (element) {
        const footerHeight = document.getElementById('vikon-footer').offsetHeight;
        $_vikon('#vikon-section').css('margin-bottom', `${footerHeight}px`);
    }
}

function setHashUrlFromEl(domObj) {
    const hashForElement = domObj.attr('href');
    if (hashForElement !== 'undefined' && hashForElement.indexOf('#') === 0) {
        if (window.history && history.pushState) {
            // IE10, Firefox, Chrome, etc.
            window.history.replaceState(null, null, hashForElement);
        } else {
            // old
            const pos = $_vikon(window).scrollTop(); // get scroll position
            window.location.hash = hashForElement;
            $_vikon(window).scrollTop(pos); // set scroll position back
        }
    }
}

function openPathToElem(pathToElem) {
    if (pathToElem.length > 0) {
        $_vikon.each(pathToElem, (index, piecePath) => {
            const tab = $_vikon('.nav-tabs , #nav-menu-list').find(`${' a[href="' + '#'}${piecePath}"]`);
            if (tab.length > 0) {
                tab.tab('show');
            } else {
                setTimeout(() => {
                    if ($_vikon(`#${piecePath}`).length) {
                        $_vikon('html,body').animate({scrollTop: $_vikon(`#${piecePath}`).offset().top}, 'high');
                    }
                }, 500);
            }
        });
    }
}

function createOpenPathToElem(domObj) {
    const hashPieces = [];
    const hashForElement = domObj.attr('id');
    if (hashForElement !== 'undefined') {
        hashPieces.unshift(hashForElement);
        const parentsPanes = $_vikon(domObj.parents('.tab-content .tab-pane'));
        $_vikon.each(parentsPanes, (index, tabPane) => {
            if ($_vikon(tabPane).attr('id') !== 'undefined') {
                hashPieces.unshift($_vikon(tabPane).attr('id'));
            }
        });
    }
    return hashPieces;
}

$_vikon(window).on('resize', () => {
    setContentMarginBottom();
});

$_vikon(document).ready(() => {
    $_vikon('#vikon-wrapper').show();
    setContentMarginBottom();
    const {hash} = location;
    if (hash.replace('#', '')) {
        if (hash.indexOf('#abitur_') >= 0) {
            const newHash = hash.replace('#abitur_', '');
            $_vikon('[id=abitur-hrefs]').find(`[data-href=${newHash}]`).click();
        } else {
            const el = $_vikon(hash);
            if (el.length == 1) {
                openPathToElem(createOpenPathToElem(el));
            }
        }
    }

    $_vikon('.open-tooltip-anchor').tooltip({
        placement: 'left',
        scrollableElement: 'html,body',
        template: '<span class="anchor-tooltip-wrap text-primary" role="tooltip" >'
            + '<span class="tooltip-inner transparent"></span></span>',
        trigger: 'hover focus',
        title() {
            return `<a  class="anchor-get"  href="#${$_vikon(this).attr('id')}">`
                + '<span class="glyphicon glyphicon-link" aria-hidden="true"></span>'
                + '</a>';
        },
        html: true,
        delay: {show: 50, hide: 1600},
    });

    $_vikon(document)
        .on('click', '.anchor-get, #nav-menu-list a, .nav-tabs a', function (e) {
            setHashUrlFromEl($_vikon(this));
        })
        .on('click', '#abitur_stoimost_link', (e) => {
            openPathToElem(createOpenPathToElem($_vikon('#anchor_paidEduStoimDocLink')));
        })
        .on('click', '.resizing-box + .read-more .button', function () {
            const $elem = $_vikon(this).parent().prev('.resizing-box');
            $_vikon('.anchor-tooltip-wrap').remove();
            if ($elem.hasClass('short')) {
                $elem.removeClass('short');
                $_vikon(this).text('Свернуть');
            } else {
                $elem.addClass('short');
                $_vikon(this).text('Развернуть');
            }
        });

    $_vikon('.tr-accordion').on('click', function () {
        const $currentTr = $_vikon(this);
        const span = $currentTr.find('span.glyphicon');
        const label = $currentTr.find('span.show-or-hide-text');
        const $table = $currentTr.closest('table');
        const id = $currentTr.data('id');
        if (!span.hasClass('glyphicon-minus')) {
            span.addClass('glyphicon-minus');
            label.html('&nbsp;Скрыть');
            $table.find(`tr[data-tr-id=${id}]`).show();
        } else {
            span.removeClass('glyphicon-minus');
            label.html('&nbsp;Показать');
            $table.find(`tr[data-tr-id=${id}]`).hide();
        }
    });
});
